import Navbar from "./components/NavBar/navbar";
import Intro from "./components/Intro/intro";
import Skills from "./components/Skills/skills";
import Works from './components/Works/works';
import Curriculum from "./components/Curriculum/curriculum";
import Contact from "./components/Contact/contact";
import Footer from "./components/Footer/footer";
import About from "./components/About/about";
import ScrollToTopButton from "./components/ScrollToTopButton/ScrollToTopButton";



function App() {
  return (
    <div className="App">
      <Navbar />
      <Intro />
      <About />
      <Skills />
      <Works />
      <Curriculum />
      <Contact />
      <Footer />
      <ScrollToTopButton />
    </div>
  );
}

export default App;
